
import Component, { mixins } from "vue-class-component";
import { Bar, mixins as chartMixins } from "vue-chartjs";
import { Prop } from "vue-property-decorator";

@Component({
    mixins: [chartMixins.reactiveProp],
})
export default class BarChart extends mixins(Bar) {
	@Prop() chartData: any;
    mounted() {
        this.renderChart(
            this.chartData,
            { 
				responsive: true,
				maintainAspectRatio: false,
			}
        );
    }
}
